<template>
  <generic-modal :title="$t('profile')" ref="generic_modal" :is_wide="true">
    <form>
      <div class="tabs is-toggle is-fullwidth" ref="tabs">
        <ul>
          <li
            class="is-active"
            data-tab="general"
            @click="change_active_tab($event, this)"
          >
            <a>
              <i class="info icon" aria-hidden="true"></i>
              <span>{{ $t("general") }}</span>
            </a>
          </li>
          <li data-tab="welcome" @click="change_active_tab($event, this)">
            <a>
              <i class="cube icon" aria-hidden="true"></i>
              <span>{{ $t("welcome") }}</span>
            </a>
          </li>
          <li data-tab="document" @click="change_active_tab($event, this)">
            <a>
              <i class="cube icon" aria-hidden="true"></i>
              <span>{{ $t("document") }}</span>
            </a>
          </li>
          <li data-tab="face" @click="change_active_tab($event, this)">
            <a>
              <i class="cube icon" aria-hidden="true"></i>
              <span>{{ $t("face") }}</span>
            </a>
          </li>
          <li data-tab="poa" @click="change_active_tab($event, this)">
            <a>
              <i class="cube icon" aria-hidden="true"></i>
              <span>{{ $t("poa") }}</span>
            </a>
          </li>
          <li data-tab="complete" @click="change_active_tab($event, this)">
            <a>
              <i class="cube icon" aria-hidden="true"></i>
              <span>{{ $t("complete") }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="is-fluid" ref="contents">
        <div class="" data-tab="general">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("name") }}</label>
                <div class="control">
                  <input
                    type="text"
                    class="input"
                    v-model="meta.name"
                    :placeholder="$t('name')"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("verification reports") }}</label>
                <div class="select">
                  <select v-model="meta.settings.verification_reports" multiple>
                    <option>{{ "document" }}</option>
                    <option>{{ "facial_similarity_photo" }}</option>
                    <option>{{ "facial_similarity_photo_fully_auto" }}</option>
                    <option>{{ "facial_similarity_video" }}</option>
                    <option>{{ "known_faces" }}</option>
                    <option>{{ "identity_enhaced" }}</option>
                    <option>{{ "watchlist_enhaced" }}</option>
                    <option>{{ "watchlist_standard" }}</option>
                    <option>{{ "watchlist_peps_only" }}</option>
                    <option>{{ "watchlist_sanctions_only" }}</option>
                    <option>{{ "proof_of_address" }}</option>
                    <option>{{ "right_to_work" }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("url for sdk token") }}</label>
                <p class="control is-expanded has-icons-left">
                  <input
                    type="text"
                    class="input"
                    v-model="meta.settings.url_sdk_token"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-server"></i>
                  </span>
                </p>
              </div>
            </div>
            <div class="column"></div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("url sdk js") }}</label>
                <p class="control is-expanded has-icons-left">
                  <input
                    type="text"
                    class="input"
                    v-model="meta.settings.url_sdk_js"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-key"></i>
                  </span>
                </p>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("api key") }}</label>
                <p class="control is-expanded has-icons-left">
                  <input
                    type="text"
                    class="input"
                    v-model="meta.settings.api_key"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-key"></i>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("options") }}</label>
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_cross_device_policy"
                  v-model="meta.settings.cross_device_policy"
                />
                <label for="chk_cross_device_policy">{{
                  $t("cross device policy")
                }}</label>
              </div>
            </div>
          </div>

          <!-- <div class="field">
        <label class="label">{{ $t("referrer") }}</label>
        <p class="control is-expanded has-icons-left">
          <input type="text" class="input" v-model="meta.settings.referrer" />
          <span class="icon is-small is-left">
            <i class="fa fa-server"></i>
          </span>
        </p>
      </div> -->
        </div>
        <div class="is-hidden" data-tab="welcome">
          <div class="title is-5">{{ $t("welcome step") }}</div>
          <div class="columns mb-0">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("is active") }}</label>
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_is_welcome_active"
                  v-model="meta.settings.is_welcome_active"
                />
                <label for="chk_is_welcome_active">{{ $t("is active") }}</label>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("title") }}</label>
                <p class="control is-expanded has-icons-left">
                  <input
                    type="text"
                    class="input"
                    v-model="meta.settings.welcome_title"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-key"></i>
                  </span>
                </p>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("button text") }}</label>
                <p class="control is-expanded has-icons-left">
                  <input
                    type="text"
                    class="input"
                    v-model="meta.settings.welcome_button_text"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-key"></i>
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div class="field">
            <label class="label">{{ $t("description") }}</label>
            <p class="control is-expanded has-icons-left">
              <textarea
                class="textarea"
                v-model="meta.settings.welcome_description"
              ></textarea>
            </p>
          </div>
        </div>
        <div class="is-hidden" data-tab="document">
          <div class="title is-5">{{ $t("document step") }}</div>
          <div class="columns mb-0">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("is active") }}</label>
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_is_document_active"
                  v-model="meta.settings.is_document_active"
                />
                <label for="chk_is_document_active">{{
                  $t("is active")
                }}</label>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("allowed documents") }}</label>
                <div class="control">
                  <input
                    class="is-checkradio"
                    type="checkbox"
                    id="chk_document_residence_permit"
                    v-model="meta.settings.document_residence_permit_allowed"
                  />
                  <label for="chk_document_residence_permit">{{
                    $t("residence permit")
                  }}</label>
                </div>
                <div class="control">
                  <input
                    class="is-checkradio"
                    type="checkbox"
                    id="chk_document_driver_license"
                    v-model="meta.settings.document_driver_license_allowed"
                  />
                  <label for="chk_document_driver_license">{{
                    $t("driver license")
                  }}</label>
                </div>
                <div class="control">
                  <input
                    class="is-checkradio"
                    type="checkbox"
                    id="chk_document_national_id"
                    v-model="meta.settings.document_national_id_allowed"
                  />
                  <label for="chk_document_national_id">{{
                    $t("national id")
                  }}</label>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("options") }}</label>
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_document_hide_country_selection"
                  v-model="meta.settings.document_hide_country_selection"
                />
                <label for="chk_document_hide_country_selection">{{
                  $t("hide country selection")
                }}</label>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("front title") }}</label>
                <p class="control is-expanded has-icons-left">
                  <input
                    type="text"
                    class="input"
                    v-model="meta.settings.document_title_front"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-key"></i>
                  </span>
                </p>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("back title") }}</label>
                <p class="control is-expanded has-icons-left">
                  <input
                    type="text"
                    class="input"
                    v-model="meta.settings.document_title_back"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-key"></i>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="is-hidden" data-tab="face">
          <div class="title is-5">{{ $t("face step") }}</div>
          <div class="columns mb-0">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("is active") }}</label>
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_is_face_active"
                  v-model="meta.settings.is_face_active"
                />
                <label for="chk_is_face_active">{{ $t("is active") }}</label>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("validation type") }}</label>
                <div class="select">
                  <select v-model="meta.settings.face_validation_type">
                    <option value="standard">{{ $t("standard") }}</option>
                    <option value="video">{{ $t("video") }}</option>
                    <option value="motion">{{ $t("motion") }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="is-hidden" data-tab="poa">
          <div class="title is-5">{{ $t("poa step") }}</div>
          <div class="columns mb-0">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("is active") }}</label>
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_is_poa_active"
                  v-model="meta.settings.is_poa_active"
                />
                <label for="chk_is_poa_active">{{ $t("is active") }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="is-hidden" data-tab="complete">
          <div class="title is-5">{{ $t("complete step") }}</div>
          <div class="columns mb-0">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("is active") }}</label>
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_is_complete_active"
                  v-model="meta.settings.is_complete_active"
                />
                <label for="chk_is_complete_active">{{
                  $t("is active")
                }}</label>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("message") }}</label>
                <p class="control is-expanded has-icons-left">
                  <input
                    type="text"
                    class="input"
                    v-model="meta.settings.complete_message"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-key"></i>
                  </span>
                </p>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("sub message") }}</label>
                <p class="control is-expanded has-icons-left">
                  <input
                    type="text"
                    class="input"
                    v-model="meta.settings.complete_sub_message"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-key"></i>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  post,
  get,
  change_active_tab,
  generate_error_message_text,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "ProfileModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      meta: { settings: {} },
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name || !v.meta.settings.api_key;
    },
  },
  methods: {
    change_active_tab,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(profile_uuid) {
      let v = this;
      v.set_initial_state();
      get("/onfido/profile", { uuid: profile_uuid })
        .then((profile) => {
          if (profile.settings && !profile.settings.verification_reports)
            profile.settings.verification_reports = [];

          v.meta = profile;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let profile = { ...v.meta };
      if (profile.uuid) {
        post("/onfido/profile", profile)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {});
      } else {
        put("/onfido/profile", profile)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {});
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
